// Ported 1:1 from the Webflow blog page (scraped/blog.html). The CMS list and the
// Finsweet category filter are rendered from posts.json instead of static items.
import { useState } from "react";
import CtaSection from "@/components/CtaSection";
import { blogCategories, posts } from "@/content/posts";

// Webflow gave the radio inputs unique ids; "News" and "HR" clashed with other elements.
const inputId = (c: string) => (c === "News" || c === "HR" ? `${c}-2` : c);

export default function BlogPage() {
  const [category, setCategory] = useState("All");
  const visible = category === "All" ? posts : posts.filter((p) => p.category === category);

  return (
    <>
      {/* Page-level custom code from the Webflow blog page's <head>. */}
      <style>{".blogimg{max-height:230px;object-fit:cover;}"}</style>
      <section className="blog-style-two-hero-section">
        <div className="default-container-2 w-container">
          <div className="text-color-blue capitalize blogsubheading">Browse Our Blog</div>
          <h1 className="change-heading-size padding-bottom-twenty bligheading marginbottom10">Find the Latest News Here</h1>
          <div className="filterpostsholder">
            <div fs-cmsfilter-element="filters" className="w-form">
              <form id="email-form" name="email-form" className="form-2" onSubmit={(e) => e.preventDefault()}>
                {blogCategories.map((c) => (
                  <label key={c} className={`filter-radio-btn-holder w-radio${c === category ? " fs-cmsfilter_active" : ""}`}>
                    <input
                      type="radio"
                      name="Category"
                      id={inputId(c)}
                      data-name="Category"
                      className="w-form-formradioinput hide w-radio-input"
                      value={c}
                      checked={c === category}
                      onChange={() => setCategory(c)}
                    />
                    <span fs-cmsfilter-field="category" className="w-form-label">
                      {c}
                    </span>
                  </label>
                ))}
              </form>
            </div>
          </div>
          <div className="collection-list-wrapper w-dyn-list">
            <div fs-cmsfilter-element="list" role="list" className="recent-blog-collection-list w-dyn-items">
              {visible.map((p) => (
                <div key={p.slug} role="listitem" className="w-dyn-item">
                  <div className="blog-card">
                    <div className="recent-blog-image-wrapper border-radius-twenty">
                      <a href={`/news/${p.slug}`} className="w-inline-block">
                        <img
                          width="800"
                          height="533"
                          alt={p.title}
                          src={p.thumbnail}
                          loading="lazy"
                          sizes="(max-width: 767px) 94vw, (max-width: 991px) 30vw, (max-width: 1439px) 31vw, 410px"
                          srcSet={p.thumbnailSrcSet || undefined}
                          className="border-radius-twenty scale-image blogimg"
                        />
                      </a>
                      <div fs-cmsfilter-value={p.category} fs-cmsfilter-field="category" className="recent-blog-category-wrapper">
                        <div fs-cmsfilter-field="category" className="recent-blog-category padding-fifteen border-radius-sixty">{p.category}</div>
                        <div fs-cmsfilter-field="category" className="recent-blog-category padding-fifteen border-radius-sixty hide">All</div>
                      </div>
                    </div>
                    <div className="padding-from-top-ten padding-bottom-ten">
                      <a href={`/news/${p.slug}`} className="heading-medium underline-off">{p.title}</a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <CtaSection />
    </>
  );
}
